<!-- ── Hero Banner ──────────────────────────────────────────────────────────── -->
<section class="cat-hero">
  <div class="cat-hero-bg"></div>
  <div class="cat-hero-overlay"></div>

  <div class="container cat-hero-inner">
    <h1 class="cat-hero-title">
      <span class="line line--1">{{ 'cats.hero_title1' | translate }}</span>
      <span class="line line--2"><em>{{ 'cats.hero_title2' | translate }}</em></span>
    </h1>
    <p class="cat-hero-sub">{{ 'cats.hero_sub' | translate }}</p>
  </div>

  <div class="cat-scroll-hint">
    <span class="cat-scroll-line"></span>
    <span class="cat-scroll-label">{{ 'cats.scroll' | translate }}</span>
  </div>
</section>

<!-- ── Meta strip ─────────────────────────────────────────────────────────── -->
<div class="cat-meta-strip">
  <div class="container cat-meta-inner">
    <span class="cat-count">{{ all_category.length }} {{ 'cats.collections_label' | translate }}</span>
    <span class="cat-meta-rule"></span>
  </div>
</div>

<!-- ── Editorial Grid ─────────────────────────────────────────────────────── -->
<section class="cat-page-section">
  <div class="container">
    <div class="cat-page-grid">
      <a
        class="cat-tile"
        *ngFor="let item of all_category; let i = index"
        (click)="cat_details(item)"
        [style.animation-delay]="(i % 4 * 0.08) + 's'"
      >
        <img [src]="item.image.image_url" [alt]="item.name" loading="lazy" />
        <div class="cat-tile-scrim">
          <h3 class="cat-tile-name">{{ item.name }}</h3>
          <span class="cat-tile-arrow"><i class="ti-arrow-right"></i></span>
        </div>
      </a>
    </div>
  </div>
</section>
